<div class="container">
  <div class="title-contact alicent">
    Contact Us
  </div>
  <div class="content_price_form" fxLayout fxLayoutWrap fxLayout="row" fxLayoutGap="" fxLayout.xs="column"
    fxLayoutAlign="center center">
    <div class="form" [formGroup]="contactForm" fxFlexOffset="10vw" fxFlex="70">

      <div class="pricing-form">
        <mat-form-field class="example-full-width">
          <mat-label>Study Category</mat-label>
          <mat-select formControlName="studyCategory">
            <mat-option *ngFor="let cat of studyCategoryArray" [value]="cat">
              {{cat}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Study title or Study Code Name</mat-label>
            <input  formControlName="studyTitle" matInput/>
          </mat-form-field>
        </div>
        <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="firstName" matInput placeholder="First Name">
          </mat-form-field>

          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="lastName" matInput placeholder="Last Name">
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width">
          <input formControlName="workEmail" type="email" email matInput placeholder="Work email">
        </mat-form-field>

        <div fxLayout fxLayout.xs="column" fxLayoutGap="20px" fxLayoutGap.xs="0" fxLayoutAlign="center center">
          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="organization" matInput placeholder="Company Name">
          </mat-form-field>

          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="jobTitle" matInput placeholder="Job title">
          </mat-form-field>
        </div>

        <mat-form-field>
          <mat-label>Size Company</mat-label>
          <mat-select formControlName="sizeCompany">
            <mat-option *ngFor="let size of sizeCompany" [value]="size">
              {{size}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <input formControlName="phone" matInput placeholder="Mobile phone">
        </mat-form-field>

        <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
          <mat-form-field fxFlex class="example-full-width">
            <input type="text" placeholder="Industry" matInput formControlName="industry" [matAutocomplete]="auto1">
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option *ngFor="let option of industryFilter | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field fxFlex class="example-full-width">
            <input type="text" placeholder="Country" matInput formControlName="country" [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let option of countryFilter | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Additional Comments <br><small>(please specify any information you think is useful)</small></mat-label>
            <textarea formControlName="comment" matInput></textarea>
          </mat-form-field>
        </div>
        
        <div class="btncontainer buttons">
          <button mat-flat-button class="btn-start-hover color-3" (click)="onSubmit()" [disabled]="!contactForm.valid">
            Send</button>
        </div>
      </div>

    </div>
    <div fxFlex=""></div>
  </div>

  <app-footer></app-footer>